const http = require('../lib/httpClient');
const { getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COMMERCE_HEADER } = require('../constants');

const endpoint = '/s/auth/v1/keys';

async function catalystGetPublicKey(tenantId, catalystBaseUrl = '') {
  const result = await http.get(`${catalystBaseUrl}${endpoint}`, {
    headers: {
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId),
      'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return undefined;
  const { keys: [firstKey] = [] } = responseBody;
  if (!firstKey) return undefined;
  return firstKey.n;
}

module.exports = catalystGetPublicKey;
